import { Instagram, MapPin, Phone, Mail } from "lucide-react";
import WaveDivider from "./WaveDivider";
import { useLang } from "../i18n/LanguageContext";

const Footer = () => {
  const { t } = useLang();
  return (
    <footer
      id="contact"
      data-testid="footer-section"
      className="relative bg-[#0b0c10]"
    >
      <WaveDivider flip color="#00FF66" opacity={0.4} />

      <div className="max-w-7xl mx-auto px-6 lg:px-10 py-16 lg:py-20">
        <div className="grid grid-cols-1 md:grid-cols-2 lg:grid-cols-4 gap-10 lg:gap-14">
          <div className="lg:col-span-1">
            <div
              className="font-heading font-extrabold tracking-[0.2em] text-white text-xl"
              style={{ textShadow: "0 0 14px rgba(0,255,102,0.4)" }}
            >
              LOKA<span className="text-[#00FF66]">.</span>BEDS
            </div>
            <p className="mt-4 text-sm text-[#9CA3AF] leading-relaxed">
              {t("foot_tagline")}
            </p>
          </div>

          <div>
            <div className="text-xs font-heading tracking-[0.3em] text-[#00FF66] uppercase mb-5">
              {t("foot_location")}
            </div>
            <div className="flex items-start gap-3 text-sm text-[#9CA3AF] leading-relaxed">
              <MapPin size={16} className="text-[#00FF66] mt-1 shrink-0" />
              <span>
                Jl. A. Yani No.123, Gilingan,
                <br />
                Kec. Banjarsari, Kota Surakarta,
                <br />
                Jawa Tengah 57123, Indonesia
              </span>
            </div>
          </div>

          <div>
            <div className="text-xs font-heading tracking-[0.3em] text-[#00FF66] uppercase mb-5">
              {t("foot_contact")}
            </div>
            <ul className="space-y-3 text-sm">
              <li>
                <a
                  href="https://wa.me/6285640170705"
                  target="_blank"
                  rel="noreferrer"
                  data-testid="footer-whatsapp"
                  className="flex items-center gap-3 text-[#9CA3AF] hover:text-[#00FF66] transition"
                >
                  <Phone size={16} className="text-[#00FF66]" />
                  +62 856-4017-0705
                </a>
              </li>
              <li>
                <a
                  href="mailto:lokabeds.zayed@gmail.com"
                  data-testid="footer-email"
                  className="flex items-center gap-3 text-[#9CA3AF] hover:text-[#00FF66] transition break-all"
                >
                  <Mail size={16} className="text-[#00FF66] shrink-0" />
                  lokabeds.zayed@gmail.com
                </a>
              </li>
            </ul>
          </div>

          <div>
            <div className="text-xs font-heading tracking-[0.3em] text-[#00FF66] uppercase mb-5">
              {t("foot_follow")}
            </div>
            <a
              href="https://www.instagram.com/lokabeds.zayed?igsh=eWF0dDQ4ZHE1YjFs"
              target="_blank"
              rel="noreferrer"
              data-testid="footer-instagram"
              className="group inline-flex items-center gap-3 px-4 py-3 rounded-full border border-[rgba(0,255,102,0.3)] hover:border-[#00FF66] hover:bg-[rgba(0,255,102,0.08)] transition-all"
            >
              <span className="inline-flex items-center justify-center w-8 h-8 rounded-full bg-[rgba(0,255,102,0.12)] border border-[rgba(0,255,102,0.3)]">
                <Instagram size={16} className="text-[#00FF66]" />
              </span>
              <span className="font-heading tracking-wider text-sm text-white group-hover:text-[#00FF66] transition">
                @lokabeds.zayed
              </span>
            </a>
            <p className="mt-4 text-xs text-[#9CA3AF]">{t("foot_follow_note")}</p>
          </div>
        </div>

        <div className="mt-14 pt-8 border-t border-white/5 flex flex-col sm:flex-row items-start sm:items-center justify-between gap-4">
          <div
            className="text-xs text-[#9CA3AF] tracking-wider"
            data-testid="footer-copyright"
          >
            Loka Beds © 2026 —{" "}
            <span className="text-white">{t("foot_copyright_slogan")}</span>
          </div>
          <div className="text-xs text-[#9CA3AF] tracking-widest uppercase font-heading">
            Rest · Reset · Go again
          </div>
        </div>
      </div>
    </footer>
  );
};

export default Footer;
